import {http} from '@/services/http'
import type {
	GetPetNamesParams,
	GetAllPetNamesParams,
	PetNamesResponse,
} from './types'

interface ErrorResponse {
	error: string
}

const API_BASE_URL = '/api/petNames'

const assertPetNamesResponse = (
	data: PetNamesResponse | ErrorResponse
): PetNamesResponse => {
	if ('error' in data) {
		throw new Error(data.error)
	}
	return data
}

export const getPetNames = async (
	params: GetPetNamesParams
): Promise<string[]> => {
	const {data} = await http.post<PetNamesResponse | ErrorResponse>(
		`${API_BASE_URL}/search`,
		params,
		{validateStatus: () => true}
	)
	return assertPetNamesResponse(data).data.names
}

export const getAllPetNames = async (
	params: GetAllPetNamesParams
): Promise<string[]> => {
	const {data} = await http.post<PetNamesResponse | ErrorResponse>(
		`${API_BASE_URL}/all`,
		params,
		{validateStatus: () => true}
	)
	return assertPetNamesResponse(data).data.names
}
